'use client';

import { Box, Grid } from '@mantine/core';
import { Suspense, useEffect } from 'react';

import Card from '@/components/Card';
import EmptyResultCard from '@/components/EmptyResultCard';
import Pagination from '@/components/Pagination';
import SidePanel from '@/components/SidePanel';
import TechblogCard from '@/features/Techblog/components/TechblogCard';
import TechblogRanking from './components/TechblogRanking';
import TechblogSearchBox from '@/features/Techblog/components/TechblogSearchBox';
import { mixpanelTrack } from '@/utils/mixpanel';
import { sendGTMEvent } from '@next/third-parties/google';
import { setLocalStorageItem } from '@/utils/localStorageControl';
import { useGetTechblogCardData } from './hook/useTechblogListMethod';
import { useScrollInit } from '@/utils/hook';
import { useTechblogListPageStyle } from './techblog.style';

const TechblogListPage = () => {
  const { classes } = useTechblogListPageStyle();

  useEffect(() => {
    useScrollInit();
    setLocalStorageItem('read-techblog', new Date().setHours(0, 0, 0, 0));
    sendGTMEvent({ event: 'page__view' });
  }, []);

  return (
    <>
      <Grid columns={24} justify={'center'}>
        <Grid.Col
          xl={6}
          lg={8}
          md={8}
          sm={24}
          xs={24}
          className={classes.sidePanelContainer}
        >
          <SidePanel fixed={false}>
            <TechblogSearchBox />
            <TechblogRanking />
          </SidePanel>
        </Grid.Col>
        <Grid.Col xl={18} lg={16} md={16} sm={24} xs={24}>
          <Suspense
            fallback={
              <Card noShadow>
                {Array(10)
                  .fill(1)
                  .map((_, index) => (
                    <TechblogCard
                      key={index}
                      techblog={{} as any}
                      loading={true}
                    />
                  ))}
              </Card>
            }
          >
            <TechblogCards />
          </Suspense>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default TechblogListPage;

const TechblogCards = () => {
  const { blogList, isLoading, page, totalPage, handlePageChange } =
    useGetTechblogCardData();

  return (
    <>
      <Box
        id="techblog-top"
        sx={(theme) => ({
          [theme.fn.smallerThan('sm')]: {
            height: 5,
          },
        })}
      />
      <Card noShadow>
        {blogList?.map((techblog) => (
          <div
            key={techblog.id}
            onClick={() => {
              mixpanelTrack('TechblogListPage_TechblogCard', 'Clicked', {
                id: techblog.id,
                techstacks: techblog.tag?.split(','),
              });
            }}
          >
            <TechblogCard techblog={techblog} loading={isLoading} />
          </div>
        ))}
        {!isLoading && blogList?.length == 0 && (
          <EmptyResultCard title={'일치하는 검색 결과가 없습니다'} />
        )}
      </Card>
      <Pagination
        totalNum={totalPage?.total_count}
        itemPerPage={10}
        pageNum={page || 1}
        onChange={handlePageChange}
      />
    </>
  );
};
